import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PublicPaymentsComponent } from './public-payments.component';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { PasswordStrengthMeterComponent } from 'angular-password-strength-meter';



@NgModule({
  declarations: [
    PublicPaymentsComponent
  ],
  imports: [
        CommonModule
        , PasswordStrengthMeterComponent
        , BrowserModule
        , FormsModule
        , ReactiveFormsModule
        , RouterModule
        , NgbPaginationModule
        , NgxMaskDirective
        , NgxMaskPipe
  ]
})
export class PublicPaymentsModule { }
